import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import { TextArea } from 'common/components/forms';
// eslint-disable-next-line import/no-cycle
import { Modal, FormError } from 'common/components/layout';
import { contactUs } from 'redux/forms/actions';

import { validateSubmit } from './validators';

class ContactFormNoCustomer extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const { order, reservation, type, email } = props;
    const data = transformData(form);
    data.email = email;
    data.type = type;
    if (type === 'Order') {
      data.orderNumber = order.orderNumber;
      data.firstName = order.billTo.firstName;
      data.lastName = order.billTo.lastName;
    }
    if (type === 'Reservation') {
      data.reservationNumber = reservation.reservationNumber;
      data.firstName = reservation.billTo.firstName;
      data.lastName = reservation.billTo.lastName;
    }

    const successFunction = () => {
      props.onSuccess();
    };
    props.contactUs(data, successFunction);
  };

  handleClose = (e) => {
    const { onCloseModal } = this.props;
    e.preventDefault();
    onCloseModal();
  };

  render() {
    const { settings, order, reservation, email, type } = this.props;
    const { handleSubmit, form } = this.props;
    const { onCloseModal } = this.props;
    if (!settings.data) {
      return (
        <Modal title="Contact Us" onCloseModal={onCloseModal}>
          &nbsp;
        </Modal>
      );
    }
    return (
      <Modal title="Contact Us" onCloseModal={onCloseModal} formName={form}>
        <FormError formName={form} />
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <p>
            {type === 'Order' && (
              <>
                {order.billTo.firstName} {order.billTo.lastName}
                <br />
                {email}
                <br />
                Order Number: {order.orderNumber}
              </>
            )}
            {type === 'Reservation' && (
              <>
                {reservation.billTo.firstName} {reservation.billTo.lastName}
                <br />
                {email}
                <br />
                Reservation Number: {reservation.reservationNumber}
              </>
            )}
          </p>
          <Field
            name="comments"
            component={TextArea}
            label="Comments"
            rows={5}
            required
          />

          <div className="c7-form__button-row">
            <a onClick={this.handleClose} className="c7-button-alt">
              Cancel
            </a>
            <button type="submit" className="c7-button">
              Submit
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = {
    comments: values.comments
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateSubmit(data);
  return errors;
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

ContactFormNoCustomer = reduxForm({
  form: 'ContactFormNoCustomer',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(ContactFormNoCustomer);

export default connect(mapStateToProps, {
  contactUs
})(ContactFormNoCustomer);
